// extracted by mini-css-extract-plugin
export default {"container":"not-found_container__yA3xS"};